<div *ngIf="item.type === 'shape'" #libTileElem class="shape-search-item-container search-result-item fx-ellipsis btn-list-item btn-free-size" draggable="true" >
    <div *ngIf="(loadThumb | async);then thumbnail else defaultImage" ></div>
    <ng-template #thumbnail>
        <div *ngIf="item.premium"  class="col-menu-item-premium">
            <div class="premium">
                <div class="icon">
                    <svg class="nu-icon">
                        <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-premium-crown"></use>
                    </svg>
                </div>
            </div>
        </div>
        <thumbnail-image
        *ngIf="item?.thumbnailType==='image' || item?.thumbnailType==='canvas'"
            class="shape-thumbnail-image"
            [defId]="item?.data.defId"
            [version]="item?.data.version"
            [url]="item.thumbnailUrl">
        </thumbnail-image>
        <!-- <thumbnail-canvas
            *ngIf="item.thumbnailType==='canvas'"
            class="shape-thumbnail-image"
            [defId]="item.data.defId"
            [version]="item.data.version"
            [style]="item.data.style"
            [focus]="focused | async"
            [canvasWidth]="canvasWidth"
            [canvasAreaWidth]="canvasAreaWidth"
            [canvasIdPrefix]="item.canvasIdPrefix">
        </thumbnail-canvas> -->
    </ng-template>
    <ng-template #defaultImage>
        <svg class="nu-icon light-nv-blue" >
            <use [attr.xlink:href]="iconHref" ></use>
        </svg>
    </ng-template>
    <label class="caption fx-ellipsis">{{item.title}}</label>
<div>